<!--新增党建引领-->
<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item><a @click="backList">党建引领管理</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="!dangjId">新增</el-breadcrumb-item>
                <el-breadcrumb-item v-if="dangjId">编辑</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form style="padding-bottom: 15px;" ref="form" :model="form" :rules="rules" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="党建标题" prop="title">
                            <el-input v-model="form.title" placeholder="请输入标题"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="党建类别" prop="category">
                            <el-select @change="changeCategory"  v-model="form.category" placeholder="请选择类别">
                                <el-option v-for="item in categoryList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="党建子类别" prop="subcategory">
                            <el-select v-model="form.subcategory" placeholder="请选择子类别">
                                <el-option v-for="item in subcategoryList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="发布时间" prop="releaseTime">
                            <el-date-picker format="YYYY-MM-DD"
                                            style="width: 100%;" v-model="form.releaseTime"
                                            type="datetime" placeholder="发布时间"
                                            value-format="x" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="党建内容" prop="content">
                            <TEditor :uploadType="1" :height="'45vh'" ref="editor"
                                     :content="form.content" v-model="form.content" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>

        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="backList">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import TEditor from '@/components/TEditor.vue';
import { serviceUrl } from "@/utils/global"
import {queryDict} from "@/api/admin/public";
import {createDangj,updateDangj,infoDangj} from "@/api/admin/dangj"

export default {
    name: "demoAdd",
    components: {
        TEditor
    },
    data() {
        return {
            serviceUrl,
            // 遮罩层
            loading: true,
            dangjId:'',
            categoryList:[],
            subcategoryList:[],
            // 表单参数
            form: {
                title: '',
                content:'',
                appContent:'',
                category:'',
                subcategory:'',
                releaseTime:'',
            },
            rules:{
                title: [{ required: true, message: "请输入标题", trigger: "blur" },],
                content: [{ required: true, message: "请输入内容", trigger: "blur" },],
                category: [{ required: true, message: "请选择党建类别", trigger: "change" },],
                subcategory: [{ required: true, message: "请选择党建子类别", trigger: "change" },],
                releaseTime: [{ required: true, message: "请选择发布时间", trigger: "blur" },],
            },
        };
    },
    created() {
        this.getQueryDict();
    },
    mounted() {
        if (this.$route.query.dangjId) {
            this.dangjId = this.$route.query.dangjId
            this.queryDangjInfo()
        }
    },
    computed: {},
    methods: {
        getQueryDict() {
            queryDict({ code: 'dj_category' }).then(res => {
                this.categoryList = res.data.data;
            })
        },
        changeCategory(){
            this.form.subcategory = '';
            this.categoryList.forEach(j => {
                if (this.form.category === j.dictKey) {
                    this.subcategoryList = j.childrenList;
                }
            })
        },
        queryDangjInfo(){
            queryDict({ code: 'dj_category' }).then(res => {
                this.categoryList = res.data.data;
                infoDangj({ dangjId: this.dangjId }).then(res => {
                    if (res.data.code === 1) {
                        this.form = res.data.data;
                        this.categoryList.forEach(j => {
                            if (this.form.category === j.dictKey) {
                                this.subcategoryList = j.childrenList;
                            }
                        })
                    }else {
                        this.$message.error("操作失败")
                    }
                })
            });

        },
        submitForm(){
            this.form.releaseTime = this.setHms(this.form.releaseTime);
            var text = JSON.parse(JSON.stringify(this.form.content))
            text = text.replace(/<video/gi,"<video style='width:96% !important;height:30% !important;background:#333 !important;'")
            text = text.replace(/<img/gi,"<img style='width: 96% !important;height:auto !important;vertical-align: middle !important;max-height:96%;margin:0 auto !important;'")
            text = text.replace(/<p style="/gi,'<p style="text-indent: unset !important;')
            this.form.appContent = text
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (!this.dangjId) {
                        createDangj(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }else {
                        this.form.dangjId = this.dangjId;
                        updateDangj(this.form).then(res => {
                            if (res.data.code === 1) {
                                this.$message.success("操作成功");
                                this.backList();
                            }else {
                                this.$message.error("操作失败")
                            }
                        })
                    }
                }
            });
        },
        backList(){
            this.$router.push({
                path: "/dangj",
            });
        },
    }
}
</script>

<style scoped>

</style>